
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";
import Typography from "@insite/mobius/Typography";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import LazyImage from "@insite/mobius/LazyImage";
import GridItem from "@insite/mobius/GridItem";
import GridContainer from "@insite/mobius/GridContainer";


const enum fields {
	sectionHeading = "sectionHeading",
	infoSection = "infoSection",
}


export interface infoModel {
	fields: {
		image: string;
		imageHeading: string;
		programInfo: string;
	};
}

interface OwnProps extends WidgetProps {
	fields: {
		[fields.sectionHeading]: string;
		[fields.infoSection]: infoModel[];
	};
}


type Props = OwnProps & WidgetProps;


export interface ProgramInfoStyles {
	infoWrapper?: InjectableCss;
	infoSec?: InjectableCss;
	imageHeading?: InjectableCss;
	sectionHead?: InjectableCss;
	imageHeadWrapper?: InjectableCss;
	programInfowrapper?: InjectableCss;
	programImageWrapper?: InjectableCss;
	infoSecWrapper?: InjectableCss;
}

export const programInfoStyles: ProgramInfoStyles = {
	infoSecWrapper: {
		css: css`
			.section-info{
				&:last-child {
					border-bottom: 1px solid #cecece;
					padding-bottom: 30px;
				}
			}
		`
	},
	infoWrapper: {
		css: css`
		display: flex;
		font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
		margin-bottom: 30px;
	`,
	},

	imageHeading: {
		css: css`
			font-weight: 300;
			line-height: 30px;
			font-size: 24px;
			color: #333;
		`
	},
	sectionHead: {
		css: css`
			font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
			font-size: 28px;
			lin-height: 34px;
			text-align: center;
			margin: 30px 0 50px 0;
		`
	},
	imageHeadWrapper: {
		css: css`
			h4{
				margin-bottom: 20px;
				font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
				text-align: center;
				font-weight: 600;
			}
			
		`
	},
	programInfowrapper: {
		css: css`
			padding-top: 25px;
			font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
		`
	},
	programImageWrapper: {
		css: css`
			${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
							justify-content: center;
					`,
						css`
							justify-content: center;
					`,
						null,
					],
					"max",
				)}
		`
	}
};

const styles = programInfoStyles;



const programInfo: React.FC<Props> = ({ id, fields }: Props) => {
	return (
		<>
			<StyledWrapper>
				<Typography as="h3" {...styles.sectionHead}> {parse(fields.sectionHeading, parserOptions)}</Typography>
			</StyledWrapper>

			<StyledWrapper {...styles.infoSecWrapper}>
				{fields.infoSection && fields.infoSection.map((item, index) => (
					<StyledWrapper className="section-info" {...styles.infoWrapper}>
						<GridContainer>
							<GridItem width={[12, 12, 4, 4, 4]} {...styles.programImageWrapper} >
								<StyledWrapper>
									<StyledWrapper {...styles.imageHeadWrapper}>
										{item.fields.imageHeading && (
											<Typography as="h4" {...styles.imageHeading}>{parse(item.fields.imageHeading, parserOptions)}</Typography>
										)
										}
									</StyledWrapper>
									<LazyImage src={item.fields.image} />
								</StyledWrapper>
							</GridItem>
							<GridItem width={[12, 12, 8, 8, 8]} {...styles.programInfowrapper} >
								<StyledWrapper  >
									{item.fields.programInfo && (
										<StyledWrapper>
											{parse(item.fields.programInfo, parserOptions)}
										</StyledWrapper>
									)
									}
								</StyledWrapper>
							</GridItem>
						</GridContainer>
					</StyledWrapper>
				))}
			</StyledWrapper>
		</>

	);
};


const basicTab = {
	displayName: "Basic",
	sortOrder: 0,
};


const widgetModule: WidgetModule = {
	component: programInfo,
	definition: {
		group: "Basic",
		fieldDefinitions: [
			{
				name: fields.sectionHeading,
				displayName: "Section Heading",
				editorTemplate: "RichTextField",
				defaultValue: "",
				fieldType: "Contextual",
				tab: basicTab,
			},
			{
				name: fields.infoSection,
				editorTemplate: "ListField",
				getDisplay: (item: HasFields) => {
					return item.fields.caption;
				},
				defaultValue: [],
				fieldType: "General",
				fieldDefinitions: [
					{
						name: "image",
						displayName: "Program Image",
						editorTemplate: "ImagePickerField",
						defaultValue: "",
					},
					{
						name: "imageHeading",
						displayName: "Program Heading",
						editorTemplate: "RichTextField",
						defaultValue: "",
					},
					{
						name: "programInfo",
						displayName: "Program Info",
						editorTemplate: "RichTextField",
						defaultValue: "",
					},


				],
			},
		],

	}

};

export default widgetModule;
